import config from "@/config";
import {i18n} from "@/locales";
import http from "@/utils/request";
import FileUpload from "@/utils/upload";

const upload = async function (file) {
  try {
    const value = await FileUpload(file);
    return {
      code: 200,
      data: value
    };
  } catch (e) {
    return {
      code: 0,
      msg: e.message || i18n("common.uploadFail"),
    }
  }
}

export default {
  upload: {
    url: `${config.API_URL}/upload`,
    name: "文件上传",
    post: async function (data, config = {}) {
      return await http.post(this.url, data, config);
    }
  },
  uploadFile: {
    // url: `${config.API_URL}/uploadFile`,
    name: "附件上传",
    post: function (data, config = {}) {
      const file = data.get("file");
      return upload(file);
    }
  },
  imageUploadFile: {
    // url: `${config.API_URL}/lqa-game/game/common/file/upload`,
    name: "附件上传",
    post: function (data, config = {}) {
      const file = data.get("file");
      return upload(file);
    }
  },
  taskFileUpload: {
    url: `${config.API_URL}/lqa-game/game/common/file/task/upload`,
    name: "附件上传",
    post: async function (data, config = {timeout: 500000}) {
      return await http.post(this.url, data, config);
    }
  },
  downProjectWord: {
    url: `${config.API_URL}/lqa-game/game/common/downPdf?wordId=`,
    name: "附件上传",
    get: async function (params) {
      return await http.get(this.url + params);
    },
  },

  exportFile: {
    url: `${config.API_URL}/fileExport`,
    name: "导出附件",
    get: async function (data, config = {}) {
      return await http.get(this.url, data, config);
    }
  },
  importFile: {
    url: `${config.API_URL}/fileImport`,
    name: "导入附件",
    post: async function (data, config = {}) {
      return await http.post(this.url, data, config);
    }
  },
  file: {
    menu: {
      url: `${config.API_URL}/file/menu`,
      name: "获取文件分类",
      get: async function () {
        return await http.get(this.url);
      }
    },
    list: {
      url: `${config.API_URL}/file/list`,
      name: "获取文件列表",
      get: async function (params) {
        return await http.get(this.url, params);
      }
    }
  },
  ocr: {
    ocrImage: {
      url: `${config.API_URL}/lqa-game/ocrutil/identify`,
      name: "获取文件分类",
      post: async function (data) {
        return await http.post(this.url, data, {
          responseType: "text"
        });
      }
    }
  },
  config: {
    getConfig: {
      url: `${config.API_URL}/lqa-game/system/config/configKey/`,
      name: "获取配置信息",
      get: async function (params) {
        return await http.get(this.url + params);
      }
    }
  },
  projectCommon: {
    getLanguageInfo: {
      url: `${config.API_URL}/lqa-game/system/project/common/getLangInfo?relationNum=`,
      name: "获取语言对信息",
      get: async function (params) {
        return await http.get(this.url + params);
      }
    },
  },
  qa: {
    getMyQADeal: {
      url: `${config.API_URL}/lqa-game/system/projectQa/getMyQAInfo`,
      name: "获取QA待办",
      get: async function (params) {
        return await http.get(this.url, params);
      }
    },
  }

}
